import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class FacilityId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): FacilityId {
    return new FacilityId(value);
  }

  /** ラベル */
  static get label(): string {
    return '施設ID';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'facilityId';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
